import React from 'react';
import classNames from 'classnames';

import lang from '../../lib/language';
import { StatementPeriodType } from '../../lib/models/fundamental/types';

import { useIsMobile } from '../../hooks';

import styles from './FinancialPeriodButtons.module.scss';

type Props = {
    currentPeriod: string;
    setPeriod: (period: StatementPeriodType) => void;
}

const FinancialPeriodButtons = (props: Props) => {
  const { currentPeriod, setPeriod } = props;
  const { isMobile } = useIsMobile();

  return (
    <div className={isMobile ? styles.mobilePeriodButtons : styles.periodButtons}>
      <button
        className={classNames(styles.periodBtn, styles.annualButton,
          { [styles.activeBtn]: currentPeriod === StatementPeriodType.ANNUAL })}
        onClick={() => setPeriod(StatementPeriodType.ANNUAL)}
        type="button"
      >
        {lang.financialsAnnualOption()}
      </button>
      <button
        className={classNames(styles.periodBtn, styles.quarterButton,
          {
            [styles.activeBtn]: currentPeriod === StatementPeriodType.QUARTERLY })}
        onClick={() => setPeriod(StatementPeriodType.QUARTERLY)}
        type="button"
      >
        {lang.financialsQuarterlyOption()}
      </button>
    </div>
  );
};

export default FinancialPeriodButtons;
